<template>
  <v-form @submit.prevent ref="form">
    <embed-form :doc="doc" />
    <div class="pa-4">
      <v-btn class="mt-5" color="amber" @click="onSubmit">Submit</v-btn>
    </div>
  </v-form>
</template>

<script>
// @ is an alias to /src
import EmbedForm from "@/views/user/exercises/timeline/EmbedForm";
import { mapState } from "vuex";

export default {
  name: "RowAdd",
  components: {
    EmbedForm,
  },
  data() {
    return {
      valid: true,
      doc: {},
    };
  },
  computed: {
    ...mapState([
      "userProfile",
      "currentUser",
      "currentProject",
      "currentProjectModel",
    ]),
  },
  methods: {
    onSubmit() {
      this.$emit("addCommit", this.doc);
    },
  },
};
</script>
